import { compose, createStore, applyMiddleware } from "redux";
import rootReducers from "./rootReducers";
import rootSagas from "./rootSagas";
import createSagaMiddleware from "@redux-saga/core";
import { routerMiddleware } from 'react-router-redux';
import { createHashHistory } from "history";
var windowObj = window;
var composeEnhancers = windowObj.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var sagaMiddleware = createSagaMiddleware();
var middlewares = [sagaMiddleware, routerMiddleware(createHashHistory())];
export var store = createStore(rootReducers, composeEnhancers(applyMiddleware.apply(void 0, middlewares)));
sagaMiddleware.run(rootSagas);



//////////////////
// WEBPACK FOOTER
// ./src/store/index.ts
// module id = 110
// module chunks = 0